import { BaseEntity, DefaultResponseWithData } from "./system";

export enum PartImageRequirementType {
  Label = 0,
  Top = 1,
  Bottom = 2,
  Left = 3,
  Right = 4,
  Front = 5,
  Back = 6,
  Misc = 7,
  SecuritySeal = 8,
  MPN = 9,
  Damage = 10,
  Vehicle = 11,
  Plug = 12,
}

export const partImageRequirementTypeLabels: Record<PartImageRequirementType, string> = {
  [PartImageRequirementType.Label]: "Label",
  [PartImageRequirementType.Top]: "Top",
  [PartImageRequirementType.Bottom]: "Bottom",
  [PartImageRequirementType.Left]: "Left",
  [PartImageRequirementType.Right]: "Right",
  [PartImageRequirementType.Front]: "Front (Main)",
  [PartImageRequirementType.Back]: "Back",
  [PartImageRequirementType.Misc]: "Misc",
  [PartImageRequirementType.SecuritySeal]: "Security Seal",
  [PartImageRequirementType.MPN]: "MPN",
  [PartImageRequirementType.Damage]: "Damage",
  [PartImageRequirementType.Vehicle]: "Vehicle",
  [PartImageRequirementType.Plug]: "Plug",
};

export const DEFAULT_IMAGE_TYPE_ORDER: PartImageRequirementType[] = [
  PartImageRequirementType.Front,
  PartImageRequirementType.Left,
  PartImageRequirementType.Right,
  PartImageRequirementType.Back,
  PartImageRequirementType.Top,
  PartImageRequirementType.Bottom,
  PartImageRequirementType.MPN,
  PartImageRequirementType.Plug,
  PartImageRequirementType.Misc,
  PartImageRequirementType.Label,
  PartImageRequirementType.SecuritySeal,
  PartImageRequirementType.Damage,
  PartImageRequirementType.Vehicle,
];

export enum WatermarkPosition {
  BottomLeft = 0,
  BottomRight = 1,
  TopLeft = 2,
  TopRight = 3,
  Center = 4,
  Diagonal = 5,
  Cover = 6,

  // Square positions: places the logo in the corner of the largest centered square
  // that fits within the image — matching how platforms like Shopify, Google, and
  // Facebook crop portrait images into a square preview.
  SquareBottomLeft  = 7,
  SquareBottomRight = 8,
  SquareTopLeft     = 9,
  SquareTopRight    = 10,
}

export interface IPartImageSettings extends BaseEntity {
  removeBackgrounds: boolean;
  numberToRemove: number;
  replaceExistingImages: boolean;
  applyWatermarks: boolean;
  grayscale: boolean;
  position: WatermarkPosition;
  transparency: number; // 0 = fully opaque, 99 = maximum transparency
  orderByImageType: boolean;
  imageTypeOrder: string | null; // JSON array of PartImageRequirementType ints

  // Listing image compression. Marketplaces are sent a resized copy; the original is always kept.
  compressListingImages: boolean;
  listingImageMaxDimension: number; // longest edge in pixels
  listingImageQuality: number; // JPEG quality, 1-100
}

export interface IPartImageSettingsResponse extends DefaultResponseWithData<IPartImageSettings> { }

/** What a given size and quality does to one real image, plus a scaled estimate. */
export interface IListingImageCompressionPreview {
  success: boolean;
  message: string | null;
  partImageId: string | null;
  originalUrl: string | null;
  originalBytes: number;
  compressedBytes: number;
  originalWidth: number;
  originalHeight: number;
  compressedWidth: number;
  compressedHeight: number;
  percentSaved: number;
  compressedDataUri: string | null;
  estimatedTotalBytesNow: number;
  estimatedTotalBytesAfter: number;
  /** How many images the estimate is based on — currently 1, so treat it as indicative. */
  sampleSize: number;
  totalListingImages: number;
}
